<template>
  <b-modal
    id="create-backup-modal"
    @hidden="hidden"
    :visible="visible"
    :no-close-on-backdrop="loading"
    :no-close-on-esc="loading"
    centered
  >
    <template #modal-header>
      <h5 class="modal-title">تهیه‌ی دستی فایل پشتیبان</h5>
    </template>
    <error-messages v-if="errorMessages.length > 0" :messages="errorMessages" />
    <p>
      این عملیات ممکن است با توجه به میزان داده‌ها، زمان‌بر و روی عملکرد سرویس
      در این بازه‌ی زمانی موثر باشد. لطفا در انجام این امر شکیبا باشید.
    </p>
    <template #modal-footer>
      <b-button variant="secondary" @click="hidden" :disabled="loading">
        انصراف
      </b-button>
      <loading-btn :loading="loading" :disabled="loading" @click="create">
        تهیه‌ی فایل پشتیبان
      </loading-btn>
    </template>
  </b-modal>
</template>

<script>
import LoadingBtn from "@/components/LoadingBtn/LoadingBtn.vue";
import ErrorMessages from "@/components/ErrorMessages/ErrorMessages.vue";
import { createBackup } from "@/services/service";

export default {
  name: "createBackupModal",
  components: {
    LoadingBtn,
    ErrorMessages
  },
  props: {
    visible: Boolean
  },
  data() {
    return {
      loading: false,
      errorMessages: []
    };
  },
  methods: {
    reset: function() {
      this.errorMessages = [];
      this.loading = false;
    },
    hidden: function() {
      this.reset();
      this.$emit("hidden");
    },
    create: async function() {
      this.loading = true;
      const [error, data] = await createBackup({
        serviceId: this.$route.params.serviceId
      });
      if (error) {
        this.errorMessages = error;
        this.loading = false;
      } else {
        if (data.apiStatus === 200) {
          this.loading = false;
          this.$emit("createSuccess");
          this.hidden();
        } else {
          this.errorMessages = data.apiErrors;
          this.loading = false;
        }
      }
    }
  }
};
</script>

<style></style>
